import { useParams } from 'react-router-dom';
import { useCheckoutState } from '../lib/use-checkout-state';
import { CheckoutStates } from '../components/CheckoutStates';

/**
 * Checkout Page - Token-based hosted checkout page
 * Route: /checkout/:token
 *
 * This page renders the checkout interface for a given checkout token.
 * It handles all checkout states: loading, payment, submitting, waiting, success, failure, cancel, expired, invalid, error
 */
export default function CheckoutPage() {
  // Get token from URL params
  const { token } = useParams<{ token: string }>();

  if (!token) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Invalid Checkout Link</h2>
          <p className="text-gray-600">
            This checkout link is not valid. Please check the link or contact the merchant.
          </p>
        </div>
      </div>
    );
  }

  // Decode the token from URL (may contain URL-encoded characters)
  const decodedToken = decodeURIComponent(token);
  const { state, session, error, upiIntent, handlePay, handleSimulatePayment, handleReturnToMerchant, handleCancel } = useCheckoutState(decodedToken);

  return (
    <CheckoutStates
      state={state}
      session={session}
      error={error}
      upiIntent={upiIntent}
      onPay={handlePay}
      onSimulatePayment={handleSimulatePayment}
      onReturnToMerchant={handleReturnToMerchant}
      onCancel={handleCancel}
    />
  );
}
